import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Iframe from './Iframe';
import { setIsBuilding, setMapData, setReferralAddress } from '../redux/Slice/referralSlice';
import { useDispatch } from 'react-redux';
import { Close } from 'common-ui-components';

const CoverageMap = ({
  name,
  disabled = false,
  coverageMessage = 'Estás en zona de cobertura. Pedilo ahora',
  noCoverageMessage = 'Todavía no tenemos cobertura en esta zona, pero podemos avisarte cuando tengamos. Dejanos tus datos.',
  coverageFWAMessage = 'Tenemos cobertura FWA',
  openModal = false,
  callAction = '',
  handleCloseModal,
  setHasCoverage,
  setOpenMap
}) => {
  const [showModal, setShowModal] = useState(false);
  const [urlMap, setUrlMap] = useState(null);
  const [urlMapCall, setUrlMapCall] = useState('');
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [address, setAddress] = useState('');
  const [coverage, setCoverage] = useState('');
  const [coverageResult, setCoverageResult] = useState(null);

  const dispatch = useDispatch();

  const findMe = () => {
    const geo = navigator.geolocation;
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    const success = (pos) => {
      const crd = pos.coords;
      if (address === '') {
        setLatitude(crd.latitude);
        setLongitude(crd.longitude);
      }
    };
    if (geo) {
      geo.getCurrentPosition(success, null, options);
    }
  };

  const getCoverageMessageByTecnology = (data) => {
    if (data?.HabilitadoVenta && data.Tecnologia && data.Tecnologia.includes('GPON')) {
      return { message: coverageMessage, type: 'GPON', hasCoverage: true };
    }

    if (!data?.HabilitadoVenta || data?.Tecnologia?.includes('FWA')) {
      return { message: noCoverageMessage, type: 'NOCOVERAGE', hasCoverage: false };
    }

    return {
      message: 'No pudimos determinar la cobertura en tu zona, vuelve a intentarlo más tarde.',
      type: 'NODATA',
      hasCoverage: false,
    };
  };

  useEffect(() => {
    if (openModal) handleShowModal();
    else setShowModal(false);
  }, [openModal]);

  useEffect(() => {
    findMe();
    fetch(`/api/urlCoverageMap`)
      .then((resp) => resp.json())
      .then((mapData) => {
        setUrlMap(mapData.urlMap);
        window.addEventListener('message', (e) => {
          if (e.origin !== mapData.urlMap) {
            return;
          }

          if (e.data.payload?.domicileInvalid) {
            setAddress('');
            return;
          }

          const data = e.data.payload;
          setLatitude(data.Latitud);
          setLongitude(data.Longitud);
          setAddress(`${data.Descripcion || ''}`);

          dispatch(
            setReferralAddress({
              address: `${data.Descripcion || ''}`,
            }),
          );
          dispatch(setMapData(data));
          const coverageMessageResult = getCoverageMessageByTecnology(data);
          setCoverage(`${coverageMessageResult.message}`);
          setCoverageResult(coverageMessageResult);
          setHasCoverage(coverageMessageResult.hasCoverage);
          dispatch(setIsBuilding(data?.Edificio === 'true'));
          handleCloseModal();
        });
      });
  }, []);

  const handleShowModal = async () => {
    if (disabled) return;
    setShowModal(true);
    findMe();
    const response = await fetch(`/api/jwtMapToken?lat=${latitude}&lon=${longitude}`);
    const data = await response.json();
    setUrlMapCall(`${urlMap}?token=${data.token}`);
  };

  return <>{showModal &&
    <div className='coverage-map-iframe'>
      <div className='validateCoverage-map-btn'>
        <button
          onClick={() => {
            setOpenMap(false);
          }}
        >
          <Close height='12' width='12'></Close> cerrar
        </button>
      </div>
      <Iframe id='frame_id' url={urlMapCall}  />
    </div>}
  </>;
};

CoverageMap.propTypes = {
  name: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  setHasCoverage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  coverageMessage: PropTypes.string,
  noCoverageMessage: PropTypes.string,
  coverageFWAMessage: PropTypes.string,
  callAction: PropTypes.string,
  openModal: PropTypes.bool,
  setOpenMap: PropTypes.func,
};

export default CoverageMap;
